import * as React from 'react';
import useStyles from './Auth0MockStaticLoginInstructions.styles';
import { MockAuth0TextField } from '../../atoms/MockAuth0TextField';
import { Trans } from '@lingui/react';
import { Icon } from '../../atoms';
import clsx from 'clsx';

export interface IAuth0MockStaticLoginInstructionsProps {}

const Auth0MockStaticLoginInstructions: React.FC<
  IAuth0MockStaticLoginInstructionsProps
> = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={clsx(classes.widget, classes.widgetOld)}>
        <Icon className={classes.logo} type={'invisalignLogo'} />
        <div className={clsx(classes.header, classes.headerOld)}>
          <div className={classes.titleOld}>
            <Trans id={'Welcome to the Invisalign® Doctor Site'} />
          </div>
        </div>
        <div className={classes.inputOld}>
          <MockAuth0TextField
            isOld={true}
            inputText={<Trans id="drusername" />}
          />
        </div>
        <div className={classes.inputOld}>
          <MockAuth0TextField
            isOld={true}
            inputText={<Trans id="staffusername" />}
          />
        </div>
        <div className={classes.inputOld}>
          <MockAuth0TextField
            isOld={true}
            inputText={
              <div className={classes.fadedText}>
                <Trans id="password" />
              </div>
            }
          />
        </div>
        <div className={classes.buttonOld}>
          <Trans id="Log in" />
        </div>
        <div className={classes.forgotLinkOld}>
          <Trans id={'Forgot Username or Password?'} />
        </div>
        <div className={classes.amDoctorLink}>
          <div className={classes.chevron}>
            <Icon className={classes.chevronIcon} type={'chevronRight'} />
          </div>
          <div className={classes.amDoctorText}>
            <Trans id={'I am a doctor'} />
          </div>
        </div>
      </div>
      <div className={classes.arrow}>
        <Icon type={'rightArrow'} />
      </div>
      <div className={clsx(classes.widget, classes.widgetNew)}>
        <div className={classes.header}>
          <div className={classes.title}>
            <Trans id={'Welcome'} />
          </div>
          <div className={classes.description}>
            <Trans id={'Log in to access your account.'} />
          </div>
        </div>
        <div>
          <div className={classes.textFieldNew}>
            <MockAuth0TextField
              placeHolder={<Trans id="Username" />}
              inputText={<Trans id="drusername+staffusername" />}
            />
          </div>
          <div className={classes.textFieldNew}>
            <MockAuth0TextField placeHolder={<Trans id="Password" />} />
          </div>
        </div>
        <div className={classes.forgotLinkNew}>
          <Trans id={'Forgot username or password?'} />
        </div>
        <div className={classes.buttonNew}>
          <Trans id="Log in" />
        </div>
      </div>
    </div>
  );
};

export default Auth0MockStaticLoginInstructions;
